// in 32.x.x hasAnyPermissions replace with import { hasAnyPermissions } from '../../../utils/helpers';
import { hasAnyPermissions, isSkunexusUser } from '../utils';

export default {
    name: 'userDetailsPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'userDetails';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                permissions: {
                    canChangePassword: hasAnyPermissions('users.change-password') && isSkunexusUser(),
                    // to remove in 32.x.x
                    canEdit: hasAnyPermissions('users.update'),
                },
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
